<template>
  <div>
    <NavbarPublicAgahiItem />
    <div class="page-wrapper full-page" style="margin-top: 100px">
      <div class="page-content">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import axios from "axios";
import NavbarPublicAgahiItem from "@/components/public/NavbarPublicAgahiItem.vue";
import { checkAuthUser } from "@/utils/checkAuth";

export default {
  components: {
    NavbarPublicAgahiItem,
  },
  data() {
    return {
      userAgent: {},
      category: [],
    };
  },

  async created() {
    await this.checkAreaAccess();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    handleResize() {
      this.userAgent = this.$root.getUserAgentDetails();
    },

    apiCallGetAgahiCategory() {
      this.showLoading2 = true;
      const url = "/public/agahi-category";
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios
        .get(url, config)
        .then((response) => {
          this.showLoading2 = false;
          const serverRespone = response.data;
          this.category = serverRespone.data;
        })
        .catch((error) => {});
    },

    async checkAreaAccess() {
      this.$store.commit("readUserToken");
      if (this.$store.state.userToken) {
        const authResponse = await checkAuthUser(
          "/v2/users/auth/validate",
          this.$store.state.userToken
        );

        this.sleep(100).then(() => {
          if (authResponse.status) {
            this.$store.state.userDetails = authResponse.data;
            this.$store.commit("setUserToken", this.$store.state.userToken);
            const redirect = this.$route.query.redirect;
            if (redirect) {
            } else {
            }
          } else {
            this.$store.commit("clearUserToken");
          }
        });
      } else {
        this.$store.commit("clearUserToken");
      }
    },
  },

  mounted() {
    this.handleResize();
    this.apiCallGetAgahiCategory();
  },
};
</script>
  
  
  <style scoped>
ul {
  list-style: none;
  padding: 0;
}
.sideBar {
  scrollbar-width: none;
  position: fixed;
  top: 0;
  width: 280px;
  height: 100vh;
  padding: 32px 16px 0 16px;
  overflow: auto;
  direction: ltr;
  border-left: 1px solid #dadada;
}
.sideBar-li {
  text-align: right;
}
.nav-link i {
  margin-left: 4px;
}

.dropdown-header-style {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  padding: 8px;
}
.router-link-active.sidebar-item-active {
  /* background-color: #bdc5d133; */
  background-color: #aeb0b333;
  font-weight: bold;
  color: #000 !important;
}
</style>